import React from "react";
import classnames from "classnames";
import { contactDirectoryDesktopOne } from "@/components/ads/GoogleAdsData";
import SingleAds from "@/components/ads/SingleAds";

interface BannerAdContainerProps {
  bodyClass: string,
  children: React.ReactNode,
  forPage?: string
}

const BannerAdContainer = ({
  bodyClass,
  children,
  forPage,
}: BannerAdContainerProps): JSX.Element => {
  const wrapperClass = `component-wrapper ${bodyClass} ${
    forPage === "contactProfile" ? "hoovers-component-wrapper" : ""
  }`;

  return (
    // <script>window["___DMK_AEM_SIX_FIVE___"]["grid"]({ });</script>
    <div className={`${wrapperClass} d-print-none`}>
      <div
        className={classnames({
          container: true,
          "w-100 spacing-pl-16": forPage === "contactProfile",
          "plr-10":
            forPage === "companyProfilePurpleAd" ||
            forPage === "contactProfilePurpleAd",
        })}
      >
        <div className="row pad-lr-0">
          <div className="col-md-12">
            <div className="colPar0 parsys">
              {children}
              <SingleAds AdName={contactDirectoryDesktopOne} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerAdContainer;
